import React from "react";
import Header from "./components/Header";
import Nav from "./components/Nav";
import Navbar from "./components/Navbar";
import Profile from "./components/Profile";
import About from "./components/About";
import Skills from "./components/Skills";
import Project from "./components/Projects";
import Footer from "./components/Footer";
import PlanningFeatures from "./components/PlanningFeatures";
import Intro from "./components/Intro";
import ProLoc from "./components/ProLoc";
import EcoVision from "./components/EcoVision";
import Values from "./components/Values";
import EcoTec from "./components/EcoTec/EcoTec";
import Partners from "./components/Partners";
import ProS from "./components/ProS";
import Services from "./components/Services";
import Invest from "./components/Invest";
import InvestRegis from "./components/InvestRegis";
import EcoInov from "./components/EcoInov";
import EcoBusiness from "./components/EcoBusiness";
import Overall from "./components/Overall";
import DevPlan from "./components/DevPlan";
import DevMile from "./components/DevMile";
import Contact from "./components/Contact";




import { BrowserRouter,Route, Switch} from "react-router-dom";



class App extends React.Component {
  render() {
    return (
      <div>
        {/* <Navbar/>
         */}
        <BrowserRouter>
        <Switch>
        <Route exact path="/" component={Profile}/>
        <Route exact path="/About" component={About}/>
        <Route exact path="/Skills" component={Skills}/>
        <Route exact path="/Project" component={Project}/>
        <Route exact path="/PlanningFeatures" component={PlanningFeatures}/>
        <Route exact path="/Intro" component={Intro}/>
        <Route exact path="/ProLoc" component={ProLoc}/>
        <Route exact path="/EcoVision" component={EcoVision}/>
        <Route exact path="/Values" component={Values}/>
        <Route exact path="/EcoTec" component={EcoTec}/>
        <Route exact path="/Partners" component={Partners}/>
        <Route exact path="/ProS" component={ProS}/>
        <Route exact path="/Services" component={Services}/>
        <Route exact path="/Invest" component={Invest}/>
        <Route exact path="/InvestRegis" component={InvestRegis}/>
        <Route exact path="/EcoBusiness" component={EcoBusiness}/>
        <Route exact path="/EcoInov" component={EcoInov}/>
        <Route exact path="/Overall" component={Overall}/>
         <Route exact path="/DevPlan" component={DevPlan}/>
         <Route exact path="/DevMile" component={DevMile}/>
         <Route exact path="/Contact" component={Contact}/>


        <Footer/>
        </Switch>
        </BrowserRouter>
        <Footer/>
      </div>
    )
  }
}
export default App;
